module.exports = __webpack_public_path__ + "static/media/maple-leaf-homes-black.080a5f4f.png";